import angular from 'angular';
import timesheetSubmissionReceiptComponent from './submission-receipt.component';


let timesheetSubmissionReceiptModule = angular.module('timesheetSubmissionReceipt', [])
  .component('timesheetSubmissionReceipt', timesheetSubmissionReceiptComponent)

export default timesheetSubmissionReceiptModule



// WEBPACK FOOTER //
// ./client/pages/timesheet/components/submission-receipt/submission-receipt.js